"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorDropdownItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var util_1 = require("@gooddata/util");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.OperatorDropdownItem = function (_a) {
    var title = _a.title, value = _a.value, isSelected = _a.isSelected, onSelect = _a.onSelect;
    var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", {
        "is-selected": isSelected,
    }, "gd-button-link", "s-rf-operator-" + util_1.stringUtils.simplifyText(title));
    return (react_1.default.createElement("button", { className: className, onClick: function () { return onSelect(value); } },
        react_1.default.createElement("span", null, title)));
};
//# sourceMappingURL=OperatorDropdownItem.js.map